const dateCommand = (msg) => {
  let date;
  var currentDate = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
  var day = currentDate.getDate();
  var month = currentDate.getMonth() + 1;
  if (month < 9) {
    month = '0' + month;
  }
  var year = currentDate.getFullYear();
  switch (msg) {
    case 'today':
      date = new Date().toISOString().slice(0, 10);
      break;
    case 'tomorrow':
      date = year + '-' + month + '-' + (day + 1);
      break;
    default:
      msg = msg + ' ' + year;
      date = new Date(msg).toISOString().slice(0, 10);
      console.log(date);
      break;
  }

  return date;
};

export default dateCommand;
